export default "__VITE_ASSET__1dry5JcZ__"